import plur from 'plur'
import * as React from 'react'
import {graphql, useFragment} from 'react-relay'

import {restApi} from '../../../../../services/rest'
import {printCount} from '../../../../../utils/printCount'
import {UserProperties} from '../../../../../utils/userProperties'
import ContentPanel from '../../../../common/ContentPanel/ContentPanel'
import {useSequenceLoaderReadyHandler} from '../../../../common/SequenceLoader/SequenceLoader.hooks'
import {getTestsLocator as getTestTreeLocator} from '../../../../packages/Tests/TestsTree/TestsTree.utils'

import ProjectInvestigationsTabTree, {
  getOccurenceTreeArg,
} from './ProjectInvestigationsTabTree.container'
import type {Props} from './ProjectInvestigationsTabTree.types'

const countFragment = graphql`
  fragment ProjectInvestigationsTabTestsTreeCountFragment on TestOccurrences {
    count
  }
`

function ProjectInvestigationsTabTestsTree({className, projectId, countKey}: Props) {
  const {count} = useFragment(countFragment, countKey) ?? {}
  const locator = getTestTreeLocator({projectId})
  const {treeReady} = restApi.endpoints.getTestOccurrenceTree.useQueryState(
    getOccurenceTreeArg(locator),
    {selectFromResult: ({data}) => ({treeReady: data != null})},
  )
  useSequenceLoaderReadyHandler(treeReady)

  const labelId = 'projectInvestigationsTabTestsTree'
  const renderContent = React.useMemo(
    () => (
      <ProjectInvestigationsTabTree labelId={labelId} projectId={projectId} locator={locator} />
    ),
    [projectId, locator],
  )
  return count != null && count !== 0 ? (
    <div className={className}>
      <ContentPanel
        panelType={UserProperties.EXPAND_PROJECT_INVESTIGATIONS_TESTS_SECTION}
        heading={
          <span id={labelId}>{`${printCount(count)} ${plur('Test', count)} Investigations`}</span>
        }
        content={renderContent}
        withBorder={false}
      />
    </div>
  ) : (
    <div>{'No active investigations.'}</div>
  )
}

export default React.memo(ProjectInvestigationsTabTestsTree)
